import React, { useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import DefaultSearchSelectInput from "../inputs/defaultSearchSelectInput";
import DefaultInput from "../inputs/defaultInput";
import DefaultButton from "../buttons/defaultButton";
import { RxCross2 } from "react-icons/rx";

const DynamicTable = ({
  columns = [
    { key: "Item", type: "text" },
    { key: "Product Code", type: "text" },
    { key: "Category", type: "dropdown" },
    { key: "Quantity", type: "number" },
  ],

  rows,
  setRows,
  buttonVariant = "default",
  error,

  handleInputChange,
}) => {
  const addRow = () => {
    const newRow = columns.reduce(
      (acc, col) => ({ ...acc, [col.key]: col.type === "number" ? 0 : "" }),
      {}
    );
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);
  };

  const removeRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const headings = [...columns.map((col) => col.label), "Actions"];

  return (
    <div className="text-sm flex flex-col gap-2 border  rounded-md pb-4">
      <table className="min-w-full ">
        <thead>
          <tr className="bg-light h-10 rounded-md ">
            {headings.map((heading, index) => (
              <th
                key={index}
                className={`text-start py-2 px-4 font-bold text-theme ${
                  index === 0 ? "!border-l-0" : ""
                } ${index === headings.length - 1 ? "!border-r-0" : ""}`}
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows &&
            !!rows.length &&
            rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={`border  p-2 ${
                      colIndex === 0 ? "!border-l-0" : ""
                    } ${
                      colIndex === columns.length - 1 ? "!border-r-0" : ""
                    }  `}
                  >
                    {column.type === "dropdown" ? (
                      <DefaultSearchSelectInput
                        classnames="!border border-white hover:border hover:border-borderColor bg-white"
                        options={column.options}
                        value={row[column.key]}
                        onChange={(e) => {
                          handleInputChange(rowIndex, column.key, e);
                        }}
                        error={
                          error &&
                          !!error.length &&
                          error.filter((er) => er.index === rowIndex) &&
                          error
                            .filter((er) => er.index === rowIndex)
                            .find((er) => er.key === column.key)
                            ? error
                                .filter((er) => er.index === rowIndex)
                                .map((er) =>
                                  er.key === column.key ? er.msg : false
                                )
                            : false
                        }
                      />
                    ) : (
                      <DefaultInput
                        classnames="bg-white hover:border !border border-white hover:border-borderColor"
                        value={row[column.key]}
                        onChange={(e) =>
                          handleInputChange(
                            rowIndex,
                            column.key,
                            e.target.value
                          )
                        }
                        placeholder={`Enter ${column.key}`}
                        type={column.type}
                        readOnly={column.readOnly}
                        error={
                          error &&
                          !!error.length &&
                          error.filter((er) => er.index === rowIndex) &&
                          error
                            .filter((er) => er.index === rowIndex)
                            .find((er) => er.key === column.key)
                            ? error
                                .filter((er) => er.index === rowIndex)
                                .map((er) =>
                                  er.key === column.key ? er.msg : false
                                )
                            : false
                        }
                      />
                    )}
                  </td>
                ))}
                <td className="border border-r-0 p-2">
                  <DefaultButton
                    onClick={() => removeRow(rowIndex)}
                    name={<RxCross2 />}
                    tooltip= "Cancel"
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <div className="flex gap-2 px-4">
        <DefaultButton
          icon={<MdAdd />}
          variant={buttonVariant}
          onClick={addRow}
          classnames="max-w-max"
          name="Add Row"
        />
      </div>
    </div>
  );
};

export default DynamicTable;
